"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hub = void 0;
var Hub;
(function (Hub) {
    Hub["teams"] = "Teams";
    Hub["outlook"] = "Outlook";
    Hub["office"] = "the Microsoft 365 app";
})(Hub = exports.Hub || (exports.Hub = {}));
//# sourceMappingURL=constants.js.map